import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Register from "./components/Register";
import NaverCallback from "./Server/NaverCallback";
import KakaoCallback from "./Server/KakaoCallback";
import Test_Templete from "./sample_st/Test_templete"; // 이름과 경로 확인
import Header from "./components/Header";  
import MyPage from "./components/Mypage";
import ProfileEdit from "./components/ProfileEdit";
import ResumeForm from "./components/ResumeForm";
import AnnouncementDetail from "./components/AnnouncementDetail";
import JoinForm from './pages/JoinForm';

const App: React.FC = () => {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Header/>
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Test_Templete />} />
            <Route path="/login" element={<Login />} />
            <Route path="/login/naver/callback" element={<NaverCallback />} />
            <Route path="/login/kakao/callback" element={<KakaoCallback />} />
            <Route path="/register" element={<Register />} />
            <Route path="/mypage" element={<MyPage/>}/>
            <Route path="/profile/edit" element={<ProfileEdit/>}/>
            <Route path="/resume" element={<ResumeForm/>}/>
            <Route path="/announcement/:id" element={<AnnouncementDetail />} />
            <Route path="/join" element={<JoinForm />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;


// App.jsx
/*
import './sample_st/styles.css'; // 스타일 경로는 프로젝트 구조에 따라 조정 필요

const App = () => {
  return (
    <div id="page-top">
      
      <nav className="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav">
        <div className="container px-4 px-lg-5">
          <a className="navbar-brand" href="#page-top">Start Bootstrap</a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false"
            aria-label="Toggle navigation">
            Menu <i className="fas fa-bars"></i>
          </button>
          <div className="collapse navbar-collapse" id="navbarResponsive">
            <ul className="navbar-nav ms-auto my-2 my-lg-0">
              <li className="nav-item"><a className="nav-link" href="#about">About</a></li>
              <li className="nav-item"><a className="nav-link" href="#services">Services</a></li>
              <li className="nav-item"><a className="nav-link" href="#contact">Contact</a></li>
            </ul>
          </div>
        </div>
      </nav>

      
      <header className="masthead">
        <div className="container px-4 px-lg-5 h-100">
          <div className="row gx-4 gx-lg-5 h-100 align-items-center justify-content-center text-center">
            <div className="col-lg-8 align-self-end">
              <h1 className="text-white font-weight-bold">Your Favorite Source of Free Bootstrap Themes</h1>
              <hr className="divider" />
            </div>
            <div className="col-lg-8 align-self-baseline">
              <p className="text-white-75 mb-5">Start Bootstrap can help you build better websites using the Bootstrap framework!</p>
              <a className="btn btn-primary btn-xl" href="#about">Find Out More</a>
            </div>
          </div>
        </div>
      </header>

      
      <section className="page-section bg-primary" id="about">
        <div className="container px-4 px-lg-5">
          <div className="row gx-4 gx-lg-5 justify-content-center">
            <div className="col-lg-8 text-center">
              <h2 className="text-white mt-0">We've got what you need!</h2>
              <hr className="divider divider-light" />
              <p className="text-white-75 mb-4">Start Bootstrap has everything you need to get your new website up and running in no time!</p>
              <a className="btn btn-light btn-xl" href="#services">Get Started!</a>
            </div>
          </div>
        </div>
      </section>

      
      <footer className="bg-light py-5">
        <div className="container px-4 px-lg-5"><div className="small text-center text-muted">© 2025 Your Company</div></div>
      </footer>
    </div>
  );
};

export default App;
*/


